import React from 'react';

import { TextField } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const ReactHookFormTextarea = ({ control, name, placeholder, label, rows }) => (
    <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => (
            <TextField
                error={Boolean(error)}
                fullWidth
                helperText={error?.message}
                label={label}
                multiline
                placeholder={placeholder}
                rows={rows}
                {...field}
            />
        )}
    />
);

ReactHookFormTextarea.propTypes = {
    control: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rows: PropTypes.number,
};

export default ReactHookFormTextarea;
